(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amielle-review-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amielle-review-link')) {
    customElements.define('amielle-review-link', class extends HTMLElement {
      connectedCallback() {
        this.disconnect?.abort();
        this.disconnect = new AbortController();
        this.anchor = this.querySelector('a');
        this.label = this.querySelector('.amielle-review-link__label');
        this.stars = [...this.querySelectorAll('.amielle-review-link__star')];
        if (!this.anchor || !this.label || this.stars.length !== 5) return;
        const refresh = () => this.sync();
        ['DOMContentLoaded', 'shopify:section:load', 'shopify:section:unload', 'amielle:reviews:change'].forEach(name => {
          document.addEventListener(name, refresh, { signal: this.disconnect.signal });
        });
        this.anchor.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = this.source;
          if (!target?.isConnected) return;
          event.preventDefault();
          const heading = target.querySelector('h2');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
          target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal: this.disconnect.signal });
        this.sync();
      }
      sync() {
        if (!this.anchor || !this.label) return;
        this.source = [...document.querySelectorAll('amielle-product-reviews[data-source="provided"]')].find(section => section.dataset.reviewProductId === this.dataset.productId && Number(section.dataset.reviewCount) > 0 && section.getClientRects().length > 0);
        const rating = Number(this.source?.dataset.reviewAverage);
        this.hidden = !this.source || !Number.isFinite(rating) || rating < 0 || rating > 5;
        if (this.hidden) { this.anchor.removeAttribute('href'); return; }
        this.anchor.href = '#' + this.source.id;
        this.anchor.setAttribute('aria-label', this.source.dataset.reviewLinkAccessible);
        this.label.textContent = this.source.dataset.reviewLinkLabel;
        this.stars.forEach((star, index) => star.style.setProperty('--amielle-star-fill', Math.round(Math.min(1, Math.max(0, rating - index)) * 100) + '%'));
      }
      disconnectedCallback() { this.disconnect?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
